import {
  required,
  required_if as requiredIf,
  confirmed,
  email,
  min,
  max,
  min_value as minValue,
  numeric,
} from 'vee-validate/dist/rules';
import { extend, setInteractionMode } from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: 'Este campo é obrigatório',
});

extend('email', {
  ...email,
  message: 'O email fornecido não é válido',
});

extend('confirmed', {
  ...confirmed,
  message: 'A confirmação do campo {_field_} deve ser igual',
});

extend('min', {
  ...min,
  message: 'O campo {_field_} deve conter pelo menos {length} caracteres',
});

extend('max', {
  ...max,
  message: 'O campo {_field_} não deve ter mais que {length} caracteres',
});

extend('numeric', {
  ...numeric,
  message: 'O campo {_field_} deve conter apenas números',
});

extend('min_value', {
  ...minValue,
  message: 'O campo {_field_} precisa ser {min} ou maior',
});

extend('required_if', {
  ...requiredIf,
  message: 'O campo {_field_} é obrigatório',
});

extend('cns', {
  validate: (cns) => {
    if (cns.length !== 15) return false;
    if (!['1', '2', '7', '8', '9'].includes(cns[0])) return false;

    // CNS Iniciados em 7, 8 ou 9
    if (['7', '8', '9'].includes(cns[0])) {
      const soma = cns
        .split('')
        .reduce((total, val, index) => total + val * (15 - index), 0);
      return soma % 11 === 0;
    }
    // CNS Iniciados em 1, 2
    const pis = cns.substring(0, 11);
    const soma = pis
      .split('')
      .reduce((total, val, index) => total + val * (15 - index), 0);

    const resto = soma % 11;
    const dv = resto === 0 ? 0 : 11 - resto;

    const resultado = dv === 10 ? `${pis}001${11 - ((soma + 2) % 11)}` : `${pis}000${dv}`;
    return resultado === cns;
  },
  message: 'O número do CNS fornecido não é válido',
});
